import React, { useEffect, useRef, useState, type ReactElement } from 'react'
import { Col, Form, Input, Row, Select, Switch } from 'antd'
import { connect, useDispatch } from 'react-redux'
import {
    type HomeStateProps,
    type RegisterAddress,
} from '../../../../../../Types/Client/RegisteredClients/Corporate'
import commonStyles from '../../../../../../Utils/Common.less'
import { GetCountryList } from '../../../../../../Services/Common'
import PostCodeInput from '../../../../../../Components/PostCodeInput'
import { type ListFrontEndInterface } from '../../../../../../Types/CommonType'

const CorresponseAddressForm = (props: RegisterAddress): ReactElement => {
    const {
        countryList,
        isEditing,
        toggleEditing,
        edit,
        toggleCorrBussEditing,
        form,
    } = props
    const dispatch = useDispatch()
    const hasFetchedOnce2 = useRef(false)
    const [address, setAddress] = useState({
        line_1: '',
        line_2: '',
        line_3: '',
        post_town: '',
        postcode: '',
        country: '',
    })
    useEffect(() => {
        const countryData = countryList?.find(
            (data: ListFrontEndInterface) =>
                data.label === address?.country?.toUpperCase()
        )
        if (address.line_1 !== '') {
            const AddressData = {
                corraddress1: address.line_1,
                corraddress2: address.line_2,
                corrtown: address.post_town,
                corrcountry: countryData?.label ?? '',
                corrpostcode: address.postcode,
            }
            form.setFieldsValue(AddressData)
        }
    }, [address])

    useEffect(() => {
        if (!hasFetchedOnce2.current) {
            hasFetchedOnce2.current = true
            return
        }
        GetCountryList(dispatch)
    }, [])
    return (
        <>
            <Row gutter={[16, 16]}>
                <Col span={12}>
                    <div className={commonStyles.bussinessToggle}>
                        <Switch
                            size="small"
                            checked={isEditing}
                            onChange={toggleEditing}
                        />
                        <span className={commonStyles.bussinesToggleA}>
                            Same as Office
                        </span>
                    </div>
                </Col>

                <Col span={12}>
                    <div className={commonStyles.bussinessToggle}>
                        <Switch
                            size="small"
                            checked={edit}
                            onChange={toggleCorrBussEditing}
                        />
                        <span className={commonStyles.bussinesToggleA}>
                            Same as Business
                        </span>
                    </div>
                </Col>
            </Row>

            <Form.Item
                label="Address 1"
                name="corraddress1"
                rules={[
                    {
                        required: true,
                        message: 'Please input your address one!',
                    },
                ]}
            >
                <Input allowClear maxLength={100} />
            </Form.Item>
            <Form.Item label="Address 2" name="corraddress2">
                <Input allowClear maxLength={100} />
            </Form.Item>
            <Form.Item
                label="Town"
                name="corrtown"
                rules={[
                    {
                        required: true,
                        message: 'Please input your town!',
                    },
                ]}
            >
                <Input allowClear maxLength={50} />
            </Form.Item>
            <Form.Item
                label="Country"
                name="corrcountry"
                initialValue="UNITED KINGDOM"
            >
                <Select
                    allowClear
                    showSearch
                    placeholder="Please select"
                    onChange={() => {}}
                    options={countryList?.map((country) => ({
                        value: country.label,
                        label: country.label,
                    }))}
                />
            </Form.Item>
            <PostCodeInput
                name="corrpostcode"
                label="Post Code"
                reuireMessage="Please Enter Post Code"
                placeHolder={''}
                setAddressDetails={setAddress}
            />
        </>
    )
}

const mapStateToProps = (state: any): HomeStateProps => {
    return {
        categoryDropDownList: state.initial.categoryDropDownList,
        countryList: state.common.countryList,
        corporateTaps: state.client.corporateTaps,
    }
}

export default connect(mapStateToProps)(CorresponseAddressForm)
